import axios from "axios";
import config from "../../config";
import { getToken, clearLocalData } from "../helper/utils";
export const globalRequest = async (
  url,
  method = "get",
  data = {},
  options = {},
  token = false
) => {
  //gloabl axios request for post get put and delete
  let headers = {
    "x-api-key": config.API_KEY,
  };
  if (token) {
    headers.authorization = "Bearer " + (await getToken());
  }
  let d = {
    method: method,
    url: url.includes("http") ? url : config.BASEURL + url,
    headers: headers,
    ...options,
  };

  if (data) {
    d.data = data;
  }

  let resp = new Promise((resolve, reject) => {
    axios(d)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(err?.response);
      });
  });

  return resp
    .then((response) => {
      let status = response?.status;
      if (status === 401) {
        clearLocalData();
        window.location.reload();
      }
      return response;
    })
    .catch((error) => {});
};
export default globalRequest;
